import { render, staticRenderFns } from "./strongbox.vue?vue&type=template&id=55b22c6e&"
import script from "./strongbox.vue?vue&type=script&lang=js&"
export * from "./strongbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports